import React from 'react';
import _ from 'lodash';
import SimpleShared from 'go/components/modules/requestDetails/v3/items/shared/SimpleShared';
import {
  ADDITIONAL_INFORMATION,
  CARD_TYPES,
  COST,
  PRICE,
  QUANTITY,
} from 'common/requestDetails/constants';
export default class SimpleHiring extends React.Component {
  state = {
    lineItem: this.props.item,
  };

  handleChange = (lineItem) => {
    return new Promise((resolve) => {
      this.setState({lineItem}, () => resolve());
    });
  };

  handleBlur = (fieldName) => {
    if (this.props.editable) {
      let {lineItem} = this.state;
      let {item} = this.props;
      lineItem = _.cloneDeep(lineItem);
      let itemToDisplay = {
        ...lineItem,
        [ADDITIONAL_INFORMATION]: {
          ..._.get(item, ADDITIONAL_INFORMATION), // need to bring in additional information saved outside this component
          ..._.get(lineItem, ADDITIONAL_INFORMATION),
        },
      };

      this.setState((prevState) => ({
        lineItem: {
          ...prevState.lineItem,
          bocTotals: itemToDisplay.bocTotals,
        },
      }));
      this.props.saveItem(this.props.sourcePath, itemToDisplay, fieldName);
    }
  };

  handleItemChange = (name, value, ind = -1) => {
    let attributeName = _.split(name, '.').pop();
    if (attributeName === QUANTITY) {
      return this.handleBundledItemChange(attributeName, value);
    } else if (
      this.props.costType == CARD_TYPES.STAFFING_BUNDLED &&
      attributeName === PRICE
    ) {
      return this.handleBundledItemChange(attributeName, value, ind);
    } else {
      let newLineItem = _.cloneDeep(this.props.item);
      _.set(newLineItem, name, value);
      return this.handleChange(newLineItem);
    }
  };

  handleBundledItemChange = (attributeName, value, ind = -1) => {
    let newLineItem = _.cloneDeep(this.props.item);
    let costs = _.get(newLineItem, COST);
    _.map(costs, (costArray) => {
      if (ind !== -1) {
        _.set(costArray[ind], attributeName, value);
      } else {
        _.map(costArray, (cost) => {
          _.set(cost, attributeName, value);
        });
      }
    });
    return this.handleChange(newLineItem);
  };

  handleItemChangeAndBlur = (name, value, fieldName) => {
    this.handleItemChange(name, value).then((res) => {
      this.handleBlur(fieldName);
    });
  };

  render() {
    return (
      <SimpleShared
        lineItem={this.state.lineItem}
        handleChange={this.handleChange}
        handleBlur={this.handleBlur}
        handleItemChange={this.handleItemChange}
        handleItemChangeAndBlur={this.handleItemChangeAndBlur}
        {...this.props}
      />
    );
  }
}
